import { registerPlugin } from "@capacitor/core";
export interface PermissionsPluginApi {
  requestCalendarPermissions(): Promise<Record<string, string>>;
  /**
   * Opens this app's settings screen so a user who permanently denied a permission can re-grant it.
   * Android only — iOS routes there via the `app-settings:` scheme instead (see openAppSettings.ts).
   */
  openAppSettings(): Promise<void>;
}

const PermissionsPlugin = registerPlugin<PermissionsPluginApi>("PermissionsPlugin", {});

export { PermissionsPlugin };
